export default __webpack_public_path__ + "static/home-3-e62ce492de5f6735cdaac376eb98b59a.png";